// import React, { useState, useEffect } from 'react';
// import { useLocation, Link, Navigate } from 'react-router-dom';
// import {
//   Container,
//   Grid,
//   Paper,
//   Typography,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemIcon,
//   Box,
//   TextField,
//   Button,
//   Card,
//   CardContent,
//   Divider,
//   CircularProgress,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Alert
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import PersonIcon from '@mui/icons-material/Person';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import LockIcon from '@mui/icons-material/Lock';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
// import { useSelector, useDispatch } from 'react-redux';
// import { toast } from 'react-toastify';
// import { authService } from '../features/user/userService';
// import { logout, updateUser } from '../features/user/userSlice';
// import { base_url } from '../utils/axiosConfig';
// import axios from 'axios';

// // Define menuItems
// const menuItems = [
//   { id: 'profile', label: 'Profile', icon: <PersonIcon />, path: '/profile' },
//   { id: 'account', label: 'Account', icon: <AccountCircleIcon />, path: '/account' },
//   { id: 'password', label: 'Change Password', icon: <LockIcon />, path: '/password' },
//   { id: 'address', label: 'Address', icon: <LocationOnIcon />, path: '/address' },
//   { id: 'orders', label: 'Orders', icon: <ShoppingBagIcon />, path: '/orders' },
// ];

// // Styled Components
// const ProfilePaper = styled(Paper)(({ theme }) => ({
//   padding: theme.spacing(4),
//   borderRadius: theme.shape.borderRadius * 2,
//   boxShadow: theme.shadows[3],
//   background: theme.palette.background.paper,
//   [theme.breakpoints.down('sm')]: {
//     padding: theme.spacing(2),
//   },
// }));

// const MenuItem = styled(ListItem)(({ theme, selected }) => ({
//   borderRadius: theme.shape.borderRadius,
//   margin: theme.spacing(0.5, 0),
//   padding: theme.spacing(1.5, 2),
//   backgroundColor: selected ? theme.palette.primary.main : theme.palette.background.default,
//   color: selected ? theme.palette.primary.contrastText : theme.palette.text.primary,
//   '&:hover': {
//     backgroundColor: selected ? theme.palette.primary.dark : theme.palette.action.hover,
//   },
//   transition: 'all 0.3s ease',
// }));

// const FormBox = styled(Box)(({ theme }) => ({
//   display: 'flex',
//   flexDirection: 'column',
//   gap: theme.spacing(2),
//   maxWidth: 500,
//   margin: 'auto',
// }));

// const OrderCard = styled(Card)(({ theme }) => ({
//   marginBottom: theme.spacing(2),
//   borderRadius: theme.shape.borderRadius * 1.5,
//   boxShadow: theme.shadows[2],
//   transition: 'transform 0.2s',
//   '&:hover': {
//     transform: 'translateY(-4px)',
//   },
// }));

// const UserProfile = () => {
//   const location = useLocation();
//   const dispatch = useDispatch();
//   const [activeSection, setActiveSection] = useState('profile');
 
//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const { isAuthenticated, user } = useSelector((state) => state.auth);
// const [openDeleteDialog, setOpenDeleteDialog] = useState(false); // State for dialog
//   // Set active section based on route

//   console.log(user)
//   useEffect(() => {
//     const path = location.pathname;
//     console.log('Current path:', path);
//     if (path === '/address') {
//       setActiveSection('address');
//     } else if (path === '/orders') {
//       setActiveSection('orders');
//       fetchOrders();
//     } else if (path === '/account') {
//       setActiveSection('account');
//     } else if (path === '/password') {
//       setActiveSection('password');
//     } else {
//       setActiveSection('profile');
//     }
//   }, [location.pathname]);

//   const handleOpenDeleteDialog = () => {
//     setOpenDeleteDialog(true);
//   };

//   const handleCloseDeleteDialog = () => {
//     setOpenDeleteDialog(false);
//   };

//   const handleDeleteAccount = async () => {
//     setLoading(true);
//     try {
//       // Make DELETE request to /user/:id
//       await axios.delete(`${base_url}/user/${user._id}`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem('token')}`,
//         },
//       });
//       // Clear token from localStorage
//       localStorage.removeItem('token');
//       // Dispatch logout action
//       dispatch(logout());
//       toast.success('Account deleted successfully.');
//       // Close dialog
//       setOpenDeleteDialog(false);
//       // Stay on the same page (handled by isAuthenticated redirect)
//     } catch (error) {
//       console.error('Account deletion error:', error);
//       toast.error(error.response?.data?.message || 'Failed to delete account');
//       setOpenDeleteDialog(false);
//     } finally {
//       setLoading(false);
//     }
//   };
//   // Fetch user orders
//   const fetchOrders = async () => {
//     setLoading(true);
//     try {
//       const response = await authService.getUserOrders();

//       const ordersArray = Array.isArray(response.orders) ? response.orders : [];
//       const uniqueOrders = Array.from(new Map(ordersArray.map(order => [order._id, order])).values());
//       setOrders(uniqueOrders);
//     } catch (error) {
//       console.error('Fetch orders error:', error);
//       toast.error(error.message || 'Failed to fetch orders');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Redirect to login if not authenticated
//   if (!isAuthenticated) {
//     return <Navigate to="/login" replace />;
//   }

//   // User data aligned with UserSchema
//   const userData = {
//     firstname: user?.firstname || '',
//     lastname: user?.lastname || '',
//     email: user?.email || '',
//     phoneNumber: user?.phoneNumber || '',
//     address: user?.address || { street: '', city: '', state: '' },
//     pincode: user?.pincode || '',
//     createdAt: user?.createdAt  ,
//     lastLogin: user?.lastLogin 
//   };

//   // Form handlers
//   const handleProfileUpdate = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const formData = new FormData(e.target);
//       const data = {
//         firstname: formData.get('firstname')?.trim(),
//         lastname: formData.get('lastname')?.trim(),
//         phoneNumber: formData.get('phoneNumber')?.trim(),
//       };
//       // Validate input
//       if (!data.firstname || !data.lastname || !data.phoneNumber) {
//         throw new Error('All fields are required');
//       }
//       if (!/^\d{10}$/.test(data.phoneNumber)) {
//         throw new Error('Invalid phone number');
//       }
//       const response = await authService.updateProfile(data);
//       if (!response) {
//         throw new Error('No response from server');
//       }
//       dispatch(updateUser(response));
//       toast.success('Profile updated successfully!');
//     } catch (error) {
//       console.error('Profile update error:', error);
//       toast.error(error.message || 'Failed to update profile');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePasswordChange = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const formData = new FormData(e.target);
//       const data = {
//         currentPassword: formData.get('currentPassword'),
//         newPassword: formData.get('newPassword'),
//         confirmPassword: formData.get('confirmNewPassword'),
//       };
//       if (data.newPassword !== data.confirmPassword) {
//         throw new Error('Passwords do not match');
//       }
//       if (data.newPassword.length < 6) {
//         throw new Error('Password must be at least 6 characters');
//       }
//       await authService.updatePassword(data);
//       toast.success('Password changed successfully!');
//     } catch (error) {
//       console.error('Password change error:', error);
//       toast.error(error.message || 'Failed to change password');
//     } finally {
//       setLoading(false);
//     }
//   };



//   const handleAddressUpdate = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const formData = new FormData(e.target);
//       const data = {
//         address: {
//           street: formData.get('street')?.trim(),
//           city: formData.get('city')?.trim(),
//           state: formData.get('state')?.trim(),
//         },
//         pincode: formData.get('pincode')?.trim(),
//       };
//       // Validate input
//       if (!data.address.street || !data.address.city || !data.address.state || !data.pincode) {
//         throw new Error('All address fields are required');
//       }
//       if (!/^\d{6}$/.test(data.pincode)) {
//         throw new Error('Invalid pincode');
//       }
//       const response = await authService.updateAddress(data);
//       if (!response) {
//         throw new Error('No response from server');
//       }
//       dispatch(updateUser(response));
//       toast.success('Address updated successfully!');
//     } catch (error) {
//       console.error('Address update error:', error);
//       toast.error(error.message || 'Failed to update address');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Render content based on active section
//   const renderContent = () => {
//     switch (activeSection) {
//       case 'profile':
//         return (
//           <FormBox>
//             <Typography variant="h5" gutterBottom>
//               Profile Details
//             </Typography>
//             <form onSubmit={handleProfileUpdate}>
//               <TextField
//                 label="First Name"
//                 name="firstname"
//                 defaultValue={userData.firstname}
//                 fullWidth
//                 margin="normal"
//                 variant="outlined"
//                 required
//               />
//               <TextField
//                 label="Last Name"
//                 name="lastname"
//                 defaultValue={userData.lastname}
//                 fullWidth
//                 margin="normal"
//                 variant="outlined"
//                 required
//               />
//               <TextField
//                 label="Email"
//                 value={userData.email}
//                 fullWidth
//                 margin="normal"
//                 variant="outlined"
//                 disabled
//               />
//               <TextField
//                 label="Phone Number"
//                 name="phoneNumber"
//                 defaultValue={userData.phoneNumber}
//                 fullWidth
//                 margin="normal"
//                 variant="outlined"
//                 type="tel"
//                 required
//                 inputProps={{ pattern: '[0-9]{10}' }}
//               />
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 sx={{ mt: 2 }}
//                 disabled={loading}
//               >
//                 {loading ? <CircularProgress size={24} /> : 'Save Changes'}
//               </Button>
//             </form>
//           </FormBox>
//         );
//       case 'account':
//         return (
//           <Box>
//             <Typography variant="h5" gutterBottom>
//               Account Details
//             </Typography>
//             <Divider sx={{ mb: 2 }} />
//             <Typography variant="body1" gutterBottom>
//               <strong>Email:</strong> {userData.email}
//             </Typography>
//             <Typography variant="body1" gutterBottom>
//               <strong>Account Created:</strong>{' '}
//               {user?.createdAt ? new Date(user.createdAt).toLocaleDateString() : '2025-01-01'}
//             </Typography>
//             <Typography variant="body1" gutterBottom>
//               <strong>Last Login:</strong>{' '}
//               {user?.lastLogin ? new Date(user.lastLogin).toLocaleDateString() : '2025-05-30'}
//             </Typography>
//             <Button
//               variant="contained"
//               color="secondary"
//               sx={{ mt: 2 }}
//               onClick={handleOpenDeleteDialog}
//               disabled={loading}
//               aria-label="Open delete account confirmation dialog"
//             >
//               {loading ? <CircularProgress size={24} /> : 'Delete Account'}
//             </Button>
//             <Dialog
//               open={openDeleteDialog}
//               onClose={handleCloseDeleteDialog}
//               aria-labelledby="delete-account-dialog-title"
//               aria-describedby="delete-account-dialog-description"
//             >
//               <DialogTitle id="delete-account-dialog-title">Confirm Account Deletion</DialogTitle>
//               <DialogContent>
//                 <Alert severity="warning" sx={{ mb: 2 }}>
//                   Deleting your account is permanent and cannot be undone. All your data, including orders and profile information, will be removed.
//                 </Alert>
//               </DialogContent>
//               <DialogActions>
//                 <Button
//                   onClick={handleCloseDeleteDialog}
//                   color="primary"
//                   disabled={loading}
//                   aria-label="Cancel account deletion"
//                 >
//                   Cancel
//                 </Button>
//                 <Button
//                   onClick={handleDeleteAccount}
//                   color="error"
//                   variant="contained"
//                   disabled={loading}
//                   aria-label="Confirm account deletion"
//                 >
//                   {loading ? <CircularProgress size={24} /> : 'Delete'}
//                 </Button>
//               </DialogActions>
//             </Dialog>
//           </Box>
//         );
//       case 'password':
//         return (
//           <FormBox>
//             <Typography variant="h5" gutterBottom>
//               Change Password
//             </Typography>
//             <form onSubmit={handlePasswordChange}>
//               <TextField
//                 label="Current Password"
//                 name="currentPassword"
//                 type="password"
//                 fullWidth
//                 margin="normal"
//                 variant="outlined"
//                 required
//               />
//               <TextField
//                 label="New Password"
//                 name="newPassword"
//                 type="password"
//                 fullWidth
//                 margin="normal"
//                 variant="outlined"
//                 required
//               />
//               <TextField
//                 label="Confirm New Password"
//                 name="confirmNewPassword"
//                 type="password"
//                 fullWidth
//                 margin="normal"
//                 variant="outlined"
//                 required
//               />
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 sx={{ mt: 2 }}
//                 disabled={loading}
//               >
//                 {loading ? <CircularProgress size={24} /> : 'Change Password'}
//               </Button>
//             </form>
//           </FormBox>
//         );
//     case 'address':
//   return (
//     <FormBox>
//       <Typography variant="h5" gutterBottom>
//         Edit Address
//       </Typography>
//       <form onSubmit={handleAddressUpdate}>
//         <TextField
//           label="Street"
//           name="street"
//           defaultValue={userData.address.street}
//           fullWidth
//           margin="normal"
//           variant="outlined"
//           required
//         />
//         <TextField
//           label="City"
//           name="city"
//           defaultValue={userData.address.city}
//           fullWidth
//           margin="normal"
//           variant="outlined"
//           required
//         />
//         <TextField
//           label="State"
//           name="state"
//           defaultValue={userData.address.state}
//           fullWidth
//           margin="normal"
//           variant="outlined"
//           required
//         />
//         <TextField
//           label="Pincode"
//           name="pincode"
//           defaultValue={userData.pincode}
//           fullWidth
//           margin="normal"
//           variant="outlined"
//           required
//           inputProps={{ pattern: '[0-9]{6}' }}
//         />
//         <Button
//           type="submit"
//           variant="contained"
//           color="primary"
//           sx={{ mt: 2 }}
//           disabled={loading}
//         >
//           {loading ? <CircularProgress size={24} /> : 'Save Address'}
//         </Button>
//       </form>
//     </FormBox>
//   );
//       case 'orders':
//         return (
//           <Box>
//             <Typography variant="h5" gutterBottom>
//               Your Orders
//             </Typography>
//             <Divider sx={{ mb: 2 }} />
//             {loading ? (
//               <Box display="flex" justifyContent="center" my={4}>
//                 <CircularProgress />
//               </Box>
//             ) : orders.length > 0 ? (
//               orders.map((order) => (
//                 <OrderCard key={order._id} role="region" aria-label={`Order ${order._id}`}>
//                   <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
//                     {order.orderItems[0]?.product?.images[0]?.url && (
//                       <img
                   
//  src={`${base_url}${order.orderItems[0].product.images[0].url}`}                        alt="Product"
//                         style={{ width: 50, height: 50, marginRight: 16, objectFit: 'cover' }}
//                       />
//                     )}
//                     <Box>
//                       <Typography variant="body1" fontWeight="bold">
                    
//                       </Typography>
//                       <Typography variant="body2" color="text.secondary">
//                         Items:{' '}
//                         {order.orderItems
//                           .map((item) => `Product: ${item.product?.title || 'Unknown'} (x${item.quantity})`)
//                           .join(', ')}
//                       </Typography>
//                       <Typography variant="body2" color="text.secondary">
//                         Total: ${order.totalPrice?.toFixed(2) || '0.00'}
//                       </Typography>
//                       <Typography variant="body2" color="text.secondary">
//                         Status: {order.orderStatus || 'N/A'}
//                       </Typography>
//                       <Typography variant="body2" color="text.secondary">
//                         Payment: {order.paymentInfo?.cashOndelivery ? 'Cash on Delivery' : 'N/A'}
//                       </Typography>
//                       <Typography variant="body2" color="text.secondary">
//                         Ordered On: {new Date(order.createdAt).toLocaleDateString('en-US', {
//                           month: 'short',
//                           day: 'numeric',
//                           year: 'numeric',
//                         })}
//                       </Typography>
//                       <Typography variant="body2" color="text.secondary">
//                         Tracking Number: {order.trackingNumber || 'N/A'}
//                       </Typography>
//                       <Button
//                         variant="outlined"
//                         size="small"
//                         sx={{ mt: 2 }}
//                         component={Link}
//                         to={`/order/${order._id}`}
//                         aria-label={`View details for order ${order._id}`}
//                       >
//                         View Details
//                       </Button>
//                     </Box>
//                   </CardContent>
//                 </OrderCard>
//               ))
//             ) : (
//               <Typography variant="body1" color="text.secondary">
//                 No orders found.
//               </Typography>
//             )}
//           </Box>
//         );
//       default:
//         return null;
//     }
//   };

//   return (
//     <Container maxWidth="lg" sx={{ py: 6 }}>
//       <Typography variant="h4" gutterBottom align="center" sx={{ mb: 4, fontWeight: 'bold' }}>
//         User Profile
//       </Typography>
//       <Grid container spacing={4}>
//         <Grid item xs={12} md={3}>
//           <ProfilePaper elevation={3}>
//             <Typography variant="h6" gutterBottom sx={{ pl: 2 }}>
//               Menu
//             </Typography>
//             <Divider />
//             <List>
//               {menuItems.map((item) => (
//                 <MenuItem
//                   key={item.id}
//                   selected={activeSection === item.id}
//                   component={Link}
//                   to={item.path}
//                   onClick={() => setActiveSection(item.id)}
//                 >
//                   <ListItemIcon sx={{ color: activeSection === item.id ? 'inherit' : 'text.secondary' }}>
//                     {item.icon}
//                   </ListItemIcon>
//                   <ListItemText primary={item.label} />
//                 </MenuItem>
//               ))}
//             </List>
//           </ProfilePaper>
//         </Grid>
//         <Grid item xs={12} md={9}>
//           <ProfilePaper elevation={3}>{renderContent()}</ProfilePaper>
//         </Grid>
//       </Grid>
//     </Container>
//   );
// };

// export default UserProfile;

import React, { useState, useEffect } from 'react';
import { useLocation, Link, Navigate } from 'react-router-dom';
import {
  Container,
  Grid,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Box,
  TextField,
  Button,
  Card,
  CardContent,
  Divider,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import PersonIcon from '@mui/icons-material/Person';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LockIcon from '@mui/icons-material/Lock';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { BsFillCartCheckFill } from "react-icons/bs";
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { authService } from '../features/user/userService';
import { logout, updateUser } from '../features/user/userSlice';
import { base_url } from '../utils/axiosConfig';
import axios from 'axios';

// Define menuItems with "Track Your Order" item
const menuItems = [
  { id: 'profile', label: 'Profile', icon: <PersonIcon />, path: '/profile' },
  { id: 'account', label: 'Account', icon: <AccountCircleIcon />, path: '/account' },
  { id: 'orders', label: 'My Orders', icon: <ShoppingBagIcon />, path: '/orders' },
  { id: 'track', label: 'Track Your Order', icon: <LocalShippingIcon />, path: '/track' },
  { id: 'password', label: 'Change Password', icon: <LockIcon />, path: '/password' },
];

// Styled Components
const ProfilePaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: theme.shadows[3],
  background: theme.palette.background.paper,
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
  },
}));

const MenuItem = styled(ListItem)(({ theme, selected }) => ({
  borderRadius: theme.shape.borderRadius,
  margin: theme.spacing(0.5, 0),
  padding: theme.spacing(1.5, 2),
  backgroundColor: selected ? theme.palette.primary.main : theme.palette.background.default,
  color: selected ? theme.palette.primary.contrastText : theme.palette.text.primary,
  '&:hover': {
    backgroundColor: selected ? theme.palette.primary.dark : theme.palette.action.hover,
  },
  transition: 'all 0.3s ease',
}));

const FormBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  maxWidth: 500,
  margin: 'auto',
}));

const OrderCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  borderRadius: theme.shape.borderRadius * 1.5,
  boxShadow: theme.shadows[2],
  transition: 'transform 0.2s',
  '&:hover': {
    transform: 'translateY(-4px)',
  },
}));

const UserProfile = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [activeSection, setActiveSection] = useState('profile');
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [trackLoading, setTrackLoading] = useState(false);
  const [trackingNumber, setTrackingNumber] = useState('');
  const [trackedOrder, setTrackedOrder] = useState(null);
  const [trackError, setTrackError] = useState(null);
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  // State for controlled password inputs
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');

  // User data aligned with UserSchema
  const userData = {
    firstname: user?.firstname || '',
    lastname: user?.lastname || '',
    email: user?.email || '',
    phoneNumber: user?.phoneNumber || '',
    address: user?.address || { street: '', city: '', state: '' },
    createdAt: user?.createdAt || '2025-01-01',
    lastLogin: user?.lastLogin || '2025-05-30',
  };

  useEffect(() => {
    const path = location.pathname.split('/')[1];
    const section = menuItems.find((item) => item.path === `/${path}`)?.id || 'profile';
    setActiveSection(section);
    if (section === 'orders') {
      fetchOrders();
    }
    if (section === 'track') {
      setTrackedOrder(null);
      setTrackingNumber('');
      setTrackError(null);
    }
  }, [location.pathname]);

  const handleOpenDeleteDialog = () => {
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  const handleDeleteAccount = async () => {
    setLoading(true);
    try {
      await axios.delete(`${base_url}user/${user._id}`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('customer'))?.token}`,
        },
      });
      localStorage.removeItem('customer');
      dispatch(logout());
      toast.success('Account deleted successfully.');
      setOpenDeleteDialog(false);
    } catch (error) {
      console.error('Account deletion error:', error);
      toast.error(error.response?.data?.message || 'Failed to delete account');
      setOpenDeleteDialog(false);
    } finally {
      setLoading(false);
    }
  };

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const response = await authService.getUserOrders();
      const ordersArray = Array.isArray(response.orders) ? response.orders : [];
      const uniqueOrders = Array.from(new Map(ordersArray.map((order) => [order._id, order])).values());
      setOrders(uniqueOrders);
    } catch (error) {
      console.error('Fetch orders error:', error);
      toast.error(error.message || 'Failed to fetch orders');
    } finally {
      setLoading(false);
    }
  };

  const handleTrackOrder = async (e) => {
    e.preventDefault();
    if (!trackingNumber.trim()) {
      setTrackError('Tracking number is required');
      return;
    }
    setTrackLoading(true);
    setTrackError(null);
    setTrackedOrder(null);

    try {
      const token = JSON.parse(localStorage.getItem('customer'))?.token;
      const response = await axios.post(
        `${base_url}user/trackorder`,
        { trackingNumber: trackingNumber.trim() },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      if (response.data) {
        setTrackedOrder(response.data);
        toast.success('Order found!');
      } else {
        setTrackError('No order found with this tracking number');
      }
    } catch (error) {
      console.error('Track order error:', error);
      setTrackError(error.response?.data?.message || 'Failed to track order');
      toast.error(error.response?.data?.message || 'Failed to track order');
    } finally {
      setTrackLoading(false);
    }
  };

  const handleProfileUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const data = {
        firstname: formData.get('firstname')?.trim(),
        lastname: formData.get('lastname')?.trim(),
        phoneNumber: formData.get('phoneNumber')?.trim(),
      };

      if (!data.firstname || !data.lastname || !data.phoneNumber) {
        throw new Error('All fields are required');
      }

      if (!/^\d{10}$/.test(data.phoneNumber)) {
        throw new Error('Invalid phone number');
      }

      const response = await authService.updateProfile(data);
      if (!response) {
        throw new Error('No response from server');
      }

      dispatch(updateUser(response));
      toast.success('Profile updated successfully!');
    } catch (error) {
      console.error('Profile update error:', error);
      toast.error(error.message || 'Failed to update profile');
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = {
        currentPassword,
        newPassword,
        confirmPassword: confirmNewPassword,
      };

      if (newPassword !== confirmNewPassword) {
        throw new Error('Passwords do not match');
      }
      if (newPassword.length < 3) {
        throw new Error('Password must be at least 3 characters');
      }

      await authService.updatePassword(data);
      toast.success('Password changed successfully!');
      // Clear the password fields
      setCurrentPassword('');
      setNewPassword('');
      setConfirmNewPassword('');
    } catch (error) {
      console.error('Password change error:', error);
      toast.error(error.message || 'Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  const renderContent = () => {
    switch (activeSection) {
      case 'profile':
        return (
          <FormBox>
            <Typography variant="h5" gutterBottom>
              Profile Details
            </Typography>
            <form onSubmit={handleProfileUpdate}>
              <TextField
                label="First Name"
                name="firstname"
                defaultValue={userData.firstname}
                fullWidth
                margin="normal"
                variant="outlined"
                required
              />
              <TextField
                label="Last Name"
                name="lastname"
                defaultValue={userData.lastname}
                fullWidth
                margin="normal"
                variant="outlined"
                required
              />
              <TextField
                label="Email"
                value={userData.email}
                fullWidth
                margin="normal"
                variant="outlined"
                disabled
              />
              <TextField
                label="Phone Number"
                name="phoneNumber"
                defaultValue={userData.phoneNumber}
                fullWidth
                margin="normal"
                variant="outlined"
                type="tel"
                required
                inputProps={{ pattern: '[0-9]{10}' }}
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{ mt: 2 }}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : 'Save Changes'}
              </Button>
            </form>
          </FormBox>
        );
      case 'account':
        return (
          <Box>
            <Typography variant="h5" gutterBottom>
              Account Details
            </Typography>
            <Divider sx={{ mb: 1 }} />
            <Typography variant="body1" gutterBottom>
              <strong>Email:</strong> {userData.email}
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Account Created:</strong>{' '}
              {user?.createdAt ? new Date(user.createdAt).toLocaleDateString() : '2025-01-01'}
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Last Login:</strong>{' '}
              {user?.lastLogin ? new Date(user.lastLogin).toLocaleDateString() : '2025-05-30'}
            </Typography>
            <Button
              variant="contained"
              color="secondary"
              sx={{ mt: 2 }}
              onClick={handleOpenDeleteDialog}
              disabled={loading}
              aria-label="Open delete account confirmation dialog"
            >
              {loading ? <CircularProgress size={24} /> : 'Delete Account'}
            </Button>
            <Dialog
              open={openDeleteDialog}
              onClose={handleCloseDeleteDialog}
              aria-labelledby="delete-account-dialog-title"
              aria-describedby="delete-account-dialog-description"
            >
              <DialogTitle id="delete-account-dialog-title">Confirm Account Deletion</DialogTitle>
              <DialogContent>
                <Alert severity="warning" sx={{ mb: 2 }}>
                  Deleting your account is permanent and cannot be undone. All your data, including orders and profile information, will be removed.
                </Alert>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleCloseDeleteDialog}
                  color="primary"
                  disabled={loading}
                  aria-label="Cancel account deletion"
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleDeleteAccount}
                  color="error"
                  variant="contained"
                  disabled={loading}
                  aria-label="Confirm account deletion"
                >
                  {loading ? <CircularProgress size={24} /> : 'Delete'}
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        );
      case 'password':
        return (
          <FormBox>
            <Typography variant="h5" gutterBottom>
              Change Password
            </Typography>
            <form onSubmit={handlePasswordChange}>
              <TextField
                label="Current Password"
                name="currentPassword"
                type="password"
                fullWidth
                margin="normal"
                variant="outlined"
                required
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
              />
              <TextField
                label="New Password"
                name="newPassword"
                type="password"
                fullWidth
                margin="normal"
                variant="outlined"
                required
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <TextField
                label="Confirm New Password"
                name="confirmNewPassword"
                type="password"
                fullWidth
                margin="normal"
                variant="outlined"
                required
                value={confirmNewPassword}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
              />
              <Typography variant="body2" sx={{ mt: 1, textAlign: 'right' }}>
                <a href="/forget-password" style={{ textDecoration: 'none', color: '#1976d2' }}>
                  Forgot Password?
                </a>
              </Typography>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{ mt: 2 }}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : 'Change Password'}
              </Button>
            </form>
          </FormBox>
        );
      case 'orders':
        return (
          <Box>
            <Typography variant="h6" gutterBottom fontWeight="bold">
              My Orders <span><BsFillCartCheckFill /></span>
            </Typography>
            <Divider sx={{ mb: 2 }} />
            {loading ? (
              <Box display="flex" justifyContent="center" my={4}>
                <CircularProgress size={24} />
              </Box>
            ) : orders.length > 0 ? (
              orders.map((order) => (
                <OrderCard
                  key={order._id}
                  role="region"
                  aria-label={`Order ${order._id}`}
                  sx={{ px: 2, py: 1 }}
                >
                  <CardContent
                    sx={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 2,
                      padding: '8px 0 !important',
                    }}
                  >
                    {order.orderItems[0]?.product?.images[0]?.url && (
                      <img
                        src={`${base_url}${order.orderItems[0].product.images[0].url}`}
                        alt="Product"
                        style={{
                          width: 40,
                          height: 40,
                          objectFit: 'cover',
                          borderRadius: 4,
                        }}
                      />
                    )}
                    <Box sx={{ flex: 1 }}>
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                       <Typography variant="caption" color="text.secondary">
                          <strong>Tracking Code:</strong> {order.trackingNumber || 'N/A'}
                        </Typography>
  

  <Typography variant="caption" color="text.secondary">
  <strong>Order Status:</strong>{' '}
  <span
    style={{
      color:
        order.orderStatus === 'Cancelled'
          ? 'red'
          : order.orderStatus === 'Return'
          ? 'orange'
          : 'green',
    }}
  >
    {order.orderStatus || 'N/A'}
  </span>
</Typography>

</Box>


                      <Box
                        sx={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          gap: 1.5,
                          mt: 1,
                        }}
                      >
                      <Typography variant="caption" color="text.secondary">
                          <strong>Ordered Date:</strong>{' '}
                          {new Date(order.createdAt).toLocaleDateString('en-IN')}
                        </Typography>
                      <Typography variant="caption" color="text.secondary" gutterBottom>
    <strong>Total Products : </strong> 
    {order.orderItems.reduce((total, item) => total + item.quantity, 0)}
  </Typography>
                        <Typography variant="caption" color="text.secondary">
                          <strong>Total Amount:</strong> ₹ {order.totalPrice?.toFixed(2) || '0.00'}
                        </Typography>
                        
                        <Typography variant="caption" color="text.secondary">
                          <strong>Payment Type:</strong>{' '}
                          {order.paymentInfo?.cashOndelivery || 'N/A'}
                        </Typography>
                        
                       
                      </Box>
                      <Button
                        variant="outlined"
                        size="small"
                        sx={{ mt: 2 }}
                        component={Link}
                        to={`/order/${order._id}`}
                        aria-label={`View details for order ${order._id}`}
                      >
                        View Details
                      </Button>
                    </Box>
                  </CardContent>
                </OrderCard>
              ))
            ) : (
              <Typography variant="body2" color="text.secondary">
                No orders found.
              </Typography>
            )}
          </Box>
        );
      case 'track':
        return (
          <FormBox>
            <Typography variant="h5" gutterBottom>
              Track Your Order
            </Typography>
            <form onSubmit={handleTrackOrder}>
              <TextField
                label="Tracking Number"
                name="trackingNumber"
                value={trackingNumber}
                onChange={(e) => setTrackingNumber(e.target.value)}
                fullWidth
                margin="normal"
                variant="outlined"
                required
                error={!!trackError}
                helperText={trackError}
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{ mt: 2 }}
                disabled={trackLoading}
              >
                {trackLoading ? <CircularProgress size={24} /> : 'Track Order'}
              </Button>
            </form>
            {trackedOrder && (
              <Box mt={4}>
                <Typography variant="h6" gutterBottom>
                  Order Details
                </Typography>
                <OrderCard role="region" aria-label={`Tracked Order ${trackedOrder.trackingNumber}`}>
                  <CardContent>
                    <Typography variant="body1" fontWeight="bold">
                      Tracking Number: {trackedOrder.trackingNumber}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Shipping Info:{' '}
                      {`${trackedOrder.shippingInfo.firstName} ${trackedOrder.shippingInfo.lastName}, ${trackedOrder.shippingInfo.address}, ${trackedOrder.shippingInfo.city}, ${trackedOrder.shippingInfo.state}, Landmark: ${trackedOrder.shippingInfo.landmark || 'N/A'}`}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Items:{' '}
                      {trackedOrder.orderItems
                        .map((item) => `${item.product.title} (x${item.quantity})`)
                        .join(', ')}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Total: ₹{(trackedOrder.orderItems.reduce((acc, item) => acc + item.price * item.quantity, 0)).toFixed(2)}
                    </Typography>
                  </CardContent>
                </OrderCard>
              </Box>
            )}
          </FormBox>
        );
      default:
        return null;
    }
  };

  return (
    <Container maxWidth="xl" sx={{ py: 2 }}>
      <Typography
        variant="h4"
        gutterBottom
        align="center"
        sx={{ mb: 4, fontWeight: 'bold', fontSize: { xs: '1.5rem', md: '2rem' } }}
      >
        My Profile
      </Typography>
      <Grid
        container
        spacing={2}
        direction={{ xs: 'column', md: 'row' }}
        sx={{ flexWrap: 'nowrap', overflowX: { xs: 'visible', md: 'auto' } }}
      >
        <Grid
          item
          xs={12}
          md={3}
          sx={{
            minWidth: { xs: '100%', md: '250px' },
            flexBasis: { md: '25%' },
            maxWidth: { md: '25%' },
            margin: '10px 0px'
          }}
        >
          <ProfilePaper elevation={3} sx={{ mb: { xs: 2, md: 0 }, border: 'gray 1px solid' }}>
            <Typography variant="h6" gutterBottom>
              Menu
            </Typography>
            <Divider />
            <List>
              {menuItems.map((item) => (
                <MenuItem
                  key={item.id}
                  selected={activeSection === item.id}
                  component={Link}
                  to={item.path}
                  onClick={() => setActiveSection(item.id)}
                >
                  <ListItemIcon
                    sx={{ color: activeSection === item.id ? 'inherit' : 'text.secondary' }}
                  >
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText primary={item.label} />
                </MenuItem>
              ))}
            </List>
          </ProfilePaper>
        </Grid>
        <Grid
          item
          xs={12}
          md={9}
          sx={{
            flexBasis: { md: '75%' },
            maxWidth: { md: '75%' },
            margin: '10px 0px'
          }}
        >
          <ProfilePaper elevation={3} sx={{ px: { xs: 2, md: 4 }, py: { xs: 2, md: 4 }, border: 'gray 1px solid' }}>
            {renderContent()}
          </ProfilePaper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default UserProfile;